const auditEvents = {
  bindings: {
    selection: '<',
    settings: '<',
    criteria: '<',
    filters: '<',
    area: '<',
    gridlet: '<',
  },
  templateUrl: '/modules/gridlets/audit-events/audit-events.html',
  controller: 'AuditEventsController',
};

angular
  .module('gridlets.module')
  .component('auditEvents', auditEvents);